import React from "react";

function RectangleAnim() {
  return (
    <div className="hidden animate-topBounce lg:grid grid-cols-4 gap-2 absolute left-4 bottom-1/4 ">
      <div className="h-[3px] w-[3px] bg-red-600 dark:bg-animOrange"></div>
      <div className="h-[3px] w-[3px] bg-red-600 dark:bg-animOrange"></div>
      <div className="h-[3px] w-[3px] bg-red-600 dark:bg-animOrange"></div>
      <div className="h-[3px] w-[3px] bg-red-600 dark:bg-animOrange"></div>
      <div className="h-[3px] w-[3px] bg-red-600 dark:bg-animOrange"></div>
      <div className="h-[3px] w-[3px] bg-red-600 dark:bg-animOrange"></div>
      <div className="h-[3px] w-[3px] bg-red-600 dark:bg-animOrange"></div>
      <div className="h-[3px] w-[3px] bg-red-600 dark:bg-animOrange"></div>
      <div className="h-[3px] w-[3px] bg-red-600 dark:bg-animOrange"></div>
      <div className="h-[3px] w-[3px] bg-red-600 dark:bg-animOrange"></div>
      <div className="h-[3px] w-[3px] bg-red-600 dark:bg-animOrange"></div>
      <div className="h-[3px] w-[3px] bg-red-600 dark:bg-animOrange"></div>
      <div className="h-[3px] w-[3px] bg-red-600 dark:bg-animOrange"></div>
      <div className="h-[3px] w-[3px] bg-red-600 dark:bg-animOrange"></div>
      <div className="h-[3px] w-[3px] bg-red-600 dark:bg-animOrange"></div>
      <div className="h-[3px] w-[3px] bg-red-600 dark:bg-animOrange"></div>
      <div className="h-[3px] w-[3px] bg-red-600 dark:bg-animOrange"></div>
      <div className="h-[3px] w-[3px] bg-red-600 dark:bg-animOrange"></div>
      <div className="h-[3px] w-[3px] bg-red-600 dark:bg-animOrange"></div>
      <div className="h-[3px] w-[3px] bg-red-600 dark:bg-animOrange"></div>
      <div className="h-[3px] w-[3px] bg-red-600 dark:bg-animOrange"></div>
      <div className="h-[3px] w-[3px] bg-red-600 dark:bg-animOrange"></div>
      <div className="h-[3px] w-[3px] bg-red-600 dark:bg-animOrange"></div>
      <div className="h-[3px] w-[3px] bg-red-600 dark:bg-animOrange"></div>
      <div className="h-[3px] w-[3px] bg-red-600 dark:bg-animOrange"></div>
      <div className="h-[3px] w-[3px] bg-red-600 dark:bg-animOrange"></div>
      <div className="h-[3px] w-[3px] bg-red-600 dark:bg-animOrange"></div>
      <div className="h-[3px] w-[3px] bg-red-600 dark:bg-animOrange"></div>
    </div>
  );
}

export default RectangleAnim;
